import { render, staticRenderFns } from "./Regbite.vue?vue&type=template&id=034be541&"
import script from "./Regbite.vue?vue&type=script&lang=js&"
export * from "./Regbite.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports